import { useEffect, useState } from 'react';
import { fetchProductsBySearchCriteria } from '../../services/magento/api';
import { getCustomAttribute } from './helper';
import '../styles/ProductPage.css';

const StepBundle = ({ data, updateData, setStepValidator }) => {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchBundles = async () => {
      try {
        setLoading(true);
        const filters = [
          { filters: [{ field: 'profitmaker_sku', value: 'Bundle' }] },
          { filters: [{ field: 'status', value: '1' }] },
        ];

        const result = await fetchProductsBySearchCriteria(filters);

        if (result?.items?.length) {
          const cleanedBundles = result.items.map((item) => {
            return {
              id: item.id,
              sku: item.sku,
              name: item.name,
              price: item.price,
              image:
                item.media_gallery_entries?.[0]?.file
                  ? `https://of3.stran.store/media/catalog/product${item.media_gallery_entries[0].file}`
                  : '/nexeo_logo.png',
              description: getCustomAttribute(item, 'description') || '',
              details: getCustomAttribute(item, 'short_description') || '',
            };
          });
          setBundles(cleanedBundles);
        } else {
          console.warn('No bundle products found.');
          setBundles([]);
        }
      } catch (err) {
        console.error('Failed to fetch bundles:', err);
        setBundles([]);
      } finally {
        setLoading(false);

      }
    };

    fetchBundles();
  }, []);

  useEffect(() => {
    setStepValidator(() => () => !!data.bundle);
  }, [data.bundle, setStepValidator]);

  const handleSelect = (bundle) => {
    updateData({
      bundle: bundle,
      firstChoice: null,
      secondChoice: null,
      thirdChoice: null
    });
  };

  return (
    <div className="bundle-details-container">
      {loading ? (
      <div className="loading-message">Loading gifts...</div>
      ) : (
        <>
              <h2>Select Your Gift</h2>
        <div className="bundles-grid">
          {bundles.map((bundle) => (
            <div
              key={bundle.id}
              className={`bundle-card ${data.bundle?.id === bundle.id ? 'selected' : ''}`}
              onClick={() => handleSelect(bundle)}
            >
              <img src={bundle.image} alt={bundle.name} />
              <h3>{bundle.name}</h3>
              <p>{bundle.description}</p>
              <p dangerouslySetInnerHTML={{ __html: bundle.details ?? '' }} />
              {/* <p className="price">${bundle.price?.toFixed(2)}</p> */}
              {data.bundle?.id === bundle.id && (
                <span className="selected-badge">Selected</span>
              )}
            </div>
          ))}
        </div>
        </>
      )}
    </div>
  );
};

export default StepBundle;
